const dev = {
	API_ENDPOINT_URL: 'https://booking.nextgenvr.ca/api',
	//   API_ENDPOINT_URL: 'https://admin.nextgenvr.ca/api',
	WS_ENDPOINT_URL: 'ws://booking.nextgenvr.ca/ws/'
};

const prod = {
	API_ENDPOINT_URL: 'https://booking.nextgenvr.ca/api',
	//   API_ENDPOINT_URL: 'https://admin.nextgenvr.ca/api',
	WS_ENDPOINT_URL: 'wss://booking.nextgenvr.ca/ws/'
};

const test = {
	API_ENDPOINT_URL: '/api',
	//   WS_ENDPOINT_URL: 'wss://app.expresswebs.ca/ws/'
};


const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
